
import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { fetchData, postData } from '../../../apiService';
import { Card, CardContent, TableContainer, Paper, Tooltip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@mui/material';
import Select from 'react-select';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Link } from 'react-router-dom';
import UndoIcon from '@mui/icons-material/Undo';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@mui/icons-material/Add';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

const SaleReturnApprovalCreate = () => {
    const { id, tid } = useParams();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, userId, token, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, token, logout]);

    const [tableData, setTableData] = useState([]);
    const [customerId, setCustomerId] = useState('');
    const [TripId, setTripId] = useState('');
    const [qty, setQty] = useState('');
    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [successMessages, setSuccessMessages] = useState("");
    const [errorMessages, setErrorMessages] = useState("");
    const [getDate, setGetData] = useState([]);
    const [ReturnId, setReturnIdId] = useState(null);
    const [saleData, setSaleData] = useState([]);
    const [invoiceData, setInvoiceData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [quantities, setQuantities] = useState([]);
    const [filteredSaleData, setFilteredSaleData] = useState([]);
    const [highlightedRowIndex, setHighlightedRowIndex] = useState(null);
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [lastChangedIndex, setLastChangedIndex] = useState(null);
    const [categoryId, setCategoryId] = useState('');
    const [productCategoryId, setPCategoryId] = useState('');
    const [itemId, setItemId] = useState('');
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [pcategoryOptions, setPCategoryOptions] = useState([]);
    const [itemOptions, setItemOptions] = useState([]);
    const [selectedPCategory, setSelectedPCategory] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [rate, setRate] = useState('');
    const [GSTRate, setGSTRate] = useState('');
    const [RouteName, setRouteName] = useState('');
    const [SaleId, setSaleId] = useState('');
    const [remark, setRemark] = useState("");
    const [getDatesale, setGetDatasale] = useState({
        datas: {
            RQuantity: '',
        }
    });
    useEffect(() => {
        fetchRouteTypes();
    }, []);

    // pic customers
    const fetchRouteTypes = async () => {
        try {
            const response = await fetchData('CustomerApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(route => ({
                    value: route.id,
                    label: route.name + ' ' + route.addressLine1 + ' ' + route.customerCode
                }));
                setRouteOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleCustomerChange = async (selectedOption) => {
        setSelectedCustomer(selectedOption);
        try {
            // Assuming selectedOption.value contains the CustomerId
            const params = `/${selectedOption.value}`;
            const response = await fetchData('ReturnApprovalApi', params, token);
            if (response.responseCode === '1111') {
                const dataArray = response.response_data;
                setRouteName(dataArray.routename);
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
        }
        setSelectedRoute(selectedOption);
        setCustomerId(selectedOption.value);
    };
    // const handleCustomerChange = (selectedOption) => {
    //     setSelectedCustomer(selectedOption);
    //     try {

    //         const response =  fetchData('ReturnApprovalApi', selectedOption.value, token);
    //         if (response.responseCode === '1111') {
    //             const dataArray = response.response_data;
    //             setRouteName(dataArray.routename)

    //         }
    //     } catch (error) {
    //         console.error('Error fetching Customer Details:', error);
    //     }
    //    // handleCustomerTypeChange(selectedOption);
    //     setSelectedRoute(selectedOption);
    //     setCustomerId(selectedOption.value);
    //    // setSelectedItem(null);
    // };
    // Return Qty 
    const handleQuantityChange = (index, newValue) => {
        setLastChangedIndex(index);
        const updatedQuantities = [...quantities];
        updatedQuantities[index] = newValue;
        setQuantities(updatedQuantities);
        setHighlightedRowIndex(index);
    };

    const combinedInvoiceData = selectedInvoices.flatMap(invoice => invoice.data);


    const handleRefreshClick = () => {
        window.location.reload();
    };

    //Product catgory
    useEffect(() => {
        const fetchPCategoryTypes = async () => {
            try {
                const response = await fetchData('ProductCategoryApi', `/${companyId}`, token);

                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    const options = response.response_data.map(pcat => ({
                        value: pcat.id,
                        label: pcat.name
                    }));
                    setPCategoryOptions(options);
                    setPCategoryId(dataArray[0].id);
                }
            } catch (error) {
                console.error('Error fetching categories:', error);
            }
        };

        fetchPCategoryTypes();
    }, [companyId, token]);

    const handlePCategoryChange = (selectedOption) => {
        setSelectedPCategory(selectedOption);
        fetchCategoryTypes(selectedOption.value);
        setPCategoryId(selectedOption.value);
        setSelectedItem(null);
        setSelectedCategory(null);
    };

    //varient
    const fetchCategoryTypes = async (productCategoryId) => {
        try {
            const response = await fetchData('CategoryApi', `/${companyId}/${productCategoryId}`, token);
            if (response.responseCode === '1111') {
                const dataArray = response.response_data;
                const options = dataArray.map(cat => ({
                    value: cat.id,
                    label: cat.name
                }));
                setCategoryOptions(options);
                setCategoryId(dataArray[0].id);
            }
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };
    // useEffect(() => {
    //     const fetchCategoryTypes = async () => {
    //         try {
    //             const response = await fetchData('CategoryApi', `/${companyId}/${productCategoryId}`, token);
    //             if (response.responseCode === '1111') {
    //                 const dataArray = response.response_data;
    //                 const options = response.response_data.map(cat => ({
    //                     value: cat.id,
    //                     label: cat.name
    //                 }));
    //                 setCategoryOptions(options);
    //                 setCategoryId(dataArray[0].id);
    //             }
    //         } catch (error) {
    //             console.error('Error fetching categories:', error);
    //         }
    //     };

    //     fetchCategoryTypes();
    // }, [companyId, productCategoryId, token]);

    const handleCategoryChange = (selectedOption) => {
        setSelectedCategory(selectedOption);
        fetchItemsTypes(selectedOption.value);
        setCategoryId(selectedOption.value);
        setSelectedItem(null);
    };

    // item dropdown
    const fetchItemsTypes = async (categoryId) => {
        try {
            const response = await fetchData('SaleReturnApprovalAPI', `/${companyId}/${categoryId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(item => ({
                    value: item.id,
                    label: item.name
                }));
                setItemOptions(options);
            }
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };

    const handleItemChange = async (selectedOptions) => {
        setSelectedItem(selectedOptions);
        const ItemID = selectedOptions.value;
        setItemId(ItemID);

        try {
            const response = await fetchData('ItemRateCheckingApi', `/${id}/${ItemID}`, token);
            if (response && response.response_data && response.response_data.length > 0) {
                let itemFound = false;
                response.response_data.forEach(category => {
                    if (category.Items && category.Items.length > 0) {
                        category.Items.forEach(item => {
                            if (!itemFound) {
                                console.log(`Processing item: ${item.Name}`);

                                const { Rate, GSTRate, Weight } = item;
                                const numericWeight = parseFloat(Weight);
                                setRate(Rate);
                                setGSTRate(GSTRate);
                                setNewItem((prevItem) => ({
                                    ...prevItem,
                                    weight: numericWeight,
                                }));
                                itemFound = true;
                            }
                        });
                    }
                });

                if (!itemFound) {
                    console.error('No items found in the response data');
                }
            } else {
                console.error('Invalid response structure');
            }
        } catch (error) {
            console.error('Error fetching item rate:', error);
        }
    };
    const handleAddClick = () => {
        if (selectedItem && qty && selectedPCategory) {
            const newItem = {
                itemName: selectedItem.label,
                Category: selectedPCategory.label,
                quantity: qty,
                customerId: selectedRoute.value,
                itemId: selectedItem.value
            };

            if (isDuplicateItem(newItem.itemId)) {
                alert("This Item already exists in the list.");
                return;
            }
            setTableData([...tableData, newItem]);
            // Reset form fields
            setSelectedPCategory(null);
            setSelectedCategory(null);
            setSelectedItem(null);
            setQty('');
        }
    };

    // Function to check if item already exists in tableData
    const isDuplicateItem = (itemId) => {
        return tableData.some(item => item.itemId === itemId);
    };

    //     const handleAddClick = () => {
    //         if (selectedItem && qty && selectedPCategory) {
    //             const newItem = {
    //                 itemName: selectedItem.label,
    //                 Category: selectedPCategory.label,
    //                 quantity: qty,
    //                 customerId: selectedRoute.value,
    //                 itemId: selectedItem.value
    //             };

    //             if (isDuplicateItem([...tableData, newItem])) {
    //                 alert("This Item already exists in the list.");
    //                 return;
    //             }
    //             setTableData([...tableData, newItem]);
    //             setInvoiceData([...invoiceData, newItem.itemId]);
    //             // Reset form fields
    //             // setSelectedRoute(null);
    //             setSelectedPCategory(null);
    //             setSelectedCategory(null);
    //             setSelectedItem(null);
    //             setQty('');
    //             // setRemark('');
    //         }
    //     };


    // const isDuplicateItem = (tableData) => {
    //     return tableData.some(item => invoiceData.includes(item.itemId));
    // };

    const handleDeleteClick = (index) => {
        const newData = tableData.filter((_, i) => i !== index);
        setTableData(newData);
    };

    /////////table data

    // useEffect(() => {
    //     fetchtableReturnData();
    // }, []);
    // const fetchtableReturnData = async () => {
    //     try {
    //         const response = await fetchData('SaleReturnApprovalAPI', `/SaleReturn/${id}`, token);
    //         if (response.responseCode === '1111') {
    //             const dataArray = response.response_data;
    //             setGetData(response.response_data);
    //             setGetDatasale(response.response_data);
    //             setReturnIdId(response.response_data.map(item => item.ID));
    //             //setDateInvoice(dataArray[0].invoiceDate);
    //             console.log(response);
    //             setQty(response.response_data.map(item => item.RQuantity));
    //             // setRateAfterDis(response.response_data.map(item => item.RateAfterDiscount));
    //         }
    //     } catch (error) {
    //         console.error('Error fetching sale return data:', error);
    //     }
    // };
    const [newItem, setNewItem] = useState({
        Id: '',
        quantity: 1,
    });
    //dulicate check

    const [itemList, setItemList] = useState([]);
    const AddtoListdata = (e) => {
        e.preventDefault();
        const updatedItem = { quantity: parseInt(qty) };
        setItemList([...itemList, updatedItem]);
        setNewItem({
            quantity: 1,
        });
        setSelectedItem(null);
        setQty('');
    };

    ///delete
    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = itemList.filter((_, i) => i !== itemToDeleteIndex);
            setItemList(updatedItemList);
            closeConfirmDialog();
        }
    };

    const qtyArray = qty.split(',').map(Number);
    ///////// Save
    // const submitData = async (e) => {
    //     e.preventDefault();
    //     setIsLoading(true);

    //     const saleReturnApprovalData = {
    //         CustomerId: customerId,
    //         ReturnDate: new Date(),
    //         CreatedBy: userId,
    //         CompanyId: companyId,
    //         CreatedDate: new Date(),
    //         ReturnNo: 0,
    //         Remark: remark,
    //     };

    //     const saleReturnApprovalDetails = [];

    //     tableData.forEach((item) => {
    //         if (item.quantity && parseFloat(item.quantity) > 0) {
    //             saleReturnApprovalDetails.push({
    //                 CustomerId: item.customerId,
    //                 CompanyId: companyId,
    //                 ItemId: item.itemId,
    //                 CreatedBy: userId,
    //                 CreatedDate: new Date(),
    //                 RQuantity: item.quantity
    //             });
    //         }
    //     });

    //     const CreateData = {
    //         SaleReturn: saleReturnApprovalData,
    //         SaleReturnDetails: saleReturnApprovalDetails,
    //     };

    //     try {
    //         const response = await postData('SaleReturnApprovalAPI', CreateData, token);
    //         console.log('Sale Return success:', response);
    //         setQuantities(Array(combinedInvoiceData.length).fill(""));
    //         setSuccessMessages("Sale Return successfully!");
    //         setErrorMessages("");
    //         history.push('/SaleReturnApprovalIndex');
    //         setTimeout(() => {
    //             setSuccessMessages("");
    //         }, 3000);
    //     } catch (error) {
    //         console.error('Sale Return error:', error);
    //         setIsLoading(false);

    //     }
    // };

    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);
    
        // Ensure essential variables are defined
        if (!customerId || !userId || !companyId) {
            console.error("Missing required data: customerId, userId, or companyId");
            setErrorMessages("Required data missing. Please check inputs.");
            setIsLoading(false);
            return;
        }
    
        // const saleReturnApprovalData = {
        //     CustomerId: customerId,
        //     ReturnDate: new Date().toISOString(), // Ensure date format is compatible with server
        //     CreatedBy: userId,
        //     CompanyId: companyId,
        //     CreatedDate: new Date().toISOString(),
        //     ReturnNo: 0,
        //     Remark: remark || "", // Handle case if remark is empty or undefined
        // };
        const saleReturnApprovalData = {
            TripId: parseInt(TripId)||null,
            CustomerId: customerId,
            ReturnDate: new Date(),
            CreatedBy: userId,
            CompanyId: companyId,
            SaleID: SaleId || null,
            CreatedDate: new Date(),
            ReturnNo: 0,
            Remark: remark,
            //ItemName: itemName,  // Ensure itemName is defined and holds the required 
            
            ItemName: combinedInvoiceData.find(item => item.ItemId === SaleId)?.itemName || 'Unknown',

        };
        
        const saleReturnApprovalDetails = [];
        
        // tableData.forEach((item) => {
        //     // Add only items with a valid quantity
        //     if (item.quantity && parseFloat(item.quantity) > 0) {
        //         saleReturnApprovalDetails.push({
        //             CustomerId: item.customerId || customerId, // Fallback if item.customerId is missing
        //             CompanyId: companyId,
        //             ItemId: item.itemId,
        //             CreatedBy: userId,
        //             CreatedDate: new Date().toISOString(),
        //             RQuantity: parseFloat(item.quantity) // Ensure quantity is a number
        //         });
        //     }
        // });
        tableData.forEach((item) => {
            if (item.quantity && parseFloat(item.quantity) > 0) {
                saleReturnApprovalDetails.push({
                    CustomerId: item.customerId,
                    CompanyId: companyId,
                    ItemId: item.itemId,
                    CreatedBy: userId,
                    CreatedDate: new Date(),
                    RQuantity: item.quantity,
                    ItemName: item.itemName,
                    Item: item.itemName,
                    SaleID: item.SaleID||null,
                    TripID: parseInt(TripId)||null,
                });
            }
        });
        
    
        if (saleReturnApprovalDetails.length === 0) {
            console.error("No items to return.");
            setErrorMessages("Please add items to return.");
            setIsLoading(false);
            return;
        }
    
        const CreateData = {
            SaleReturn: saleReturnApprovalData,
            SaleReturnDetails: saleReturnApprovalDetails,
        };
    
        try {
            const response = await postData('SaleReturnApprovalAPI', CreateData, token);
            console.log('Sale Return success:', response);
            setQuantities(Array(combinedInvoiceData.length).fill(""));
            setSuccessMessages("Sale Return successfully submitted!");
            setErrorMessages("");
            history.push('/SaleReturnApprovalIndex');
            setTimeout(() => setSuccessMessages(""), 3000);
        } catch (error) {
            console.error('Sale Return error:', error);
            setErrorMessages("Sale Return submission failed. Check data and try again.");
        } finally {
            setIsLoading(false);
        }
    };
    
    //scroll
    const customStyles = {
        menu: (provided) => ({
            ...provided,
            maxHeight: 170,
            overflowY: 'auto',
            scrollbarWidth: 'thin',
            msOverflowStyle: 'none',
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: 170,
            overflowY: 'auto',
            '::-webkit-scrollbar': {
                width: '8px',
            },
            '::-webkit-scrollbar-thumb': {
                background: '#ccc',
                borderRadius: '4px',
            },
        }),
    };

    return (
        <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '730px', overflow: 'auto', maxWidth: '98%' }}>
            <style>
                {`
            .container::-webkit-scrollbar {
              width: 0.1em;
            }
            .container::-webkit-scrollbar-track {
              background: rgba(255,255,255,0);
            }
            .container::-webkit-scrollbar-thumb {
              background-color: rgba(255,255,255,0);
              border-radius: 4px;
            }
          `}
            </style>
            <div>
                <div className="w-full" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
                    <div>
                        <h4 className="block uppercase text-lg font-semibold mb-4 linkcolor mr-2" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'brown' }}>Sale Return</h4>
                    </div>
                    <div >
                        <h5 style={{ marginLeft: '45%', marginTop: '-45px', color: '#02395E' }}>Route: {RouteName}</h5>

                    </div>
                    <div className="flex mb-2" style={{ justifyContent: "flex-end", marginTop: '-32px' }}>

                        <Tooltip title="Exit">
                            <Link to={`/SaleReturnApprovalIndex`} style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button variant="contained" color="error" style={{marginLeft: '10px', height: '30px'}}>
                                    Back < ExitToAppIcon />
                                </Button>
                        </Link>
                    </Tooltip>
                    <Button
                        style={{ background: 'green', color: 'white', fontWeight: 'bolder', height: '30px', marginRight: '35px',marginLeft:'10px' }}
                        onClick={submitData}
                        disabled={isLoading}
                    >
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : "Save"} <CheckCircleIcon />
                    </Button>
                </div>
                <div className='w-full mb-1' style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <div className="w-1/5 mr-2">
                        <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '14px' }}>
                            Customer
                        </label>
                        <Select
                            value={selectedRoute}
                            onChange={handleCustomerChange}
                            options={routeOptions}
                            placeholder="Select Customer"
                            styles={customStyles}
                            isSearchable
                        />
                    </div>
                    <div className="w-1/6 mr-2">
                        <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '15px' }}>
                            Category
                        </label>
                        <Select
                            value={selectedPCategory}
                            onChange={handlePCategoryChange}
                            options={pcategoryOptions}
                            placeholder="Select Category"
                            styles={customStyles}
                            isSearchable
                        />
                    </div>
                    <div className="w-1/4 mr-2">
                        <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '15px', width: '200px' }}>
                            Variant
                        </label>
                        <Select
                            value={selectedCategory}
                            onChange={handleCategoryChange}
                            options={categoryOptions}
                            placeholder="Select Category"
                            styles={customStyles}
                            isSearchable

                        />
                    </div>
                    <div className="w-1/4 mr-2">
                        <label className="block tracking-wide text-black text-xs font-bold mb-2" htmlFor="code" style={{ fontSize: '15px' }}>
                            Item
                        </label>
                        <Select
                            value={selectedItem}
                            onChange={handleItemChange}
                            options={itemOptions}
                            placeholder="Select Item"
                            isSearchable

                        />
                    </div>
                    <div className="w-1/8 mr-2" >
                        <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Quantity" style={{ fontSize: '15px' }}>
                            QTY (No.of pieces)
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            value={qty}
                            type="text"
                            placeholder="Quantity"
                            style={{ width: '150px', height: '37px' }}
                            onChange={(e) => {
                                let input = e.target.value;
                                // Allow only digits and a single dot
                                input = input.replace(/[^0-9.]/g, '');
                                // Allow only one dot
                                const dotIndex = input.indexOf('.');
                                if (dotIndex !== -1) {
                                    input = input.slice(0, dotIndex + 1) + input.slice(dotIndex + 1).replace(/\./g, '');
                                }

                                // Restrict to two digits after the dot
                                if (dotIndex !== -1 && input.length - dotIndex > 3) {
                                    input = input.slice(0, dotIndex + 3);
                                }
                                if (input.length <= 5) {
                                    setQty(input);
                                }
                            }}
                        />
                    </div>

                    <div className='w-full mb-2'>
                        <div className="w-1/2 mr-2">
                            <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Branch">
                                Remark
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={remark}
                                onChange={(e) => {
                                    const input = e.target.value;
                                    if (input.length <= 100) {
                                        setRemark(input);
                                    }
                                }}

                                type="text"
                                placeholder="Enter Remark"
                            />
                        </div>
                        <div className="w-1/2 mr-2" style={{ marginLeft: '61%', marginTop: '-37px' }}>
                            <Tooltip title="Add To Table">
                                <Button
                                    style={{ background: 'Blue', color: 'white', fontWeight: 'bolder' }} onClick={handleAddClick} disabled={isLoading}  >
                                    {isLoading ? <CircularProgress size={24} color="inherit" /> : "Add"} <AddIcon style={{ fontWeight: 'bolder' }} />
                                </Button>
                            </Tooltip>
                            <Tooltip title="Refresh">
                                <Button onClick={handleRefreshClick} startIcon={<RefreshIcon style={{ fontWeight: 'bolder' }} />} style={{ background: 'yellow', color: 'black', marginLeft: '11px', fontWeight: 'bold' }} >
                                    Refresh
                                </Button>
                            </Tooltip>

                        </div>
                    </div>

                </div>
            </div>
            <div className="w-full sm:w-full mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
                <CardContent>
                    <div className="w-full mb-4 flex">
                        <TableContainer component={Paper}>
                            <table className="min-w-full bg-white">
                                <thead className="bg-gray-800 text-white" style={{ height: '38px' }}>
                                    <tr>
                                        <th>Sl.No</th>
                                        <th>Category</th>
                                        <th>Item Name</th>
                                        <th style={{ textAlign: 'right' }}>Return Qty  <p style={{ textAlign: 'right', fontSize: '10px', marginBlock: '-7px', fontFamily: ' Times New Roman", Times, serif' }}>(No.of pieces)</p></th>
                                        <th style={{ textAlign: 'center' }}>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableData.map((item, index) => (
                                        <tr key={index}>
                                            <td className="px-4 py-2 border-r">{index + 1}</td>
                                            <td className="px-4 py-2 border-r">{item.Category}</td>
                                            <td className="px-4 py-2 border-r">{item.itemName}</td>
                                            <td className="px-4 py-2 border-r" style={{ textAlign: 'right' }}>{item.quantity}</td>
                                            <td className="px-4 py-2 border-r" style={{ textAlign: 'center' }}>
                                                <Tooltip title="Delete">
                                                    <DeleteIcon
                                                        style={{ cursor: 'pointer', color: 'violet' }} onClick={() => handleDeleteClick(index)} />
                                                </Tooltip>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                        </TableContainer>
                    </div>
                </CardContent>
            </div>
        </div>
        </div >
    );
};
export default SaleReturnApprovalCreate;
